// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3DTCT5vM2s4ZQ3iBhdN-tp{align-items:center;display:flex;flex-direction:column}._1eIyrNg52RxzLxH3c6dina{margin:0 0 1.6rem}._306U-tR_QyZd-ii3tKFKj{display:flex;flex-direction:row}._2HzYjjjkjfj8bfp9AxX3V4{display:flex;margin-right:1.2rem}@media (min-width:992px){._3DTCT5vM2s4ZQ3iBhdN-tp{flex-direction:row}._1eIyrNg52RxzLxH3c6dina{margin:0 1.2rem 0 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vote": "_3DTCT5vM2s4ZQ3iBhdN-tp",
	"text": "_1eIyrNg52RxzLxH3c6dina",
	"buttonContainer": "_306U-tR_QyZd-ii3tKFKj",
	"button": "_2HzYjjjkjfj8bfp9AxX3V4"
};
module.exports = ___CSS_LOADER_EXPORT___;
